module.exports = __webpack_public_path__ + "img/goods-5.3b0942e8.png";